// import configData from "@/config";
const isProd = process.env.NODE_ENV === 'production';
const isBeta = process.env.NODE_ENV === 'beta';

// 環境ごとの差分は .env の MIX_* で上書きする。未設定なら従来の beta 環境の値がそのまま使われる。
// バケットが ACL 非対応（BucketOwnerEnforced）の環境では、source を CloudFront ドメインにする。
const bucketSuffix = process.env.MIX_S3_BUCKET_SUFFIX || 'beta';
const audioUrl = process.env.MIX_S3_URL_AUDIO || 'https://digin-audio-beta.s3-ap-northeast-1.amazonaws.com/';
const mp3Url = process.env.MIX_S3_URL_MP3 || 'https://digin-mp3-beta.s3.ap-northeast-1.amazonaws.com/';
const wavUrl = process.env.MIX_S3_URL_WAV || 'https://digin-wav-beta.s3-ap-northeast-1.amazonaws.com/';
const assetUrl = process.env.MIX_S3_URL_ASSET || 'https://digins3-beta.s3.ap-northeast-1.amazonaws.com/';
const inquiryUrl = process.env.MIX_S3_URL_INQUIRY || 'https://digin-inquiry-beta.s3.ap-northeast-1.amazonaws.com/';

let setting = {
  "apiBaseUrl": 'http://127.0.0.1:8000/api/v1/',
  "timeZone": 'Asia/Tokyo',
  "S3": {
    region: 'ap-northeast-1',
    "audio": {
      "bucket" : `digin-audio-${bucketSuffix}`,
      "path" : "audio/",
      "source" : audioUrl
    },
    "mp3": {
      "bucket" : `digin-mp3-${bucketSuffix}`,
      "path" : "audio/",
      "source" : mp3Url
    },
    "wav": {
      "bucket" : `digin-wav-${bucketSuffix}`,
      "path" : "audio/",
      "source" : wavUrl
      // 因為上傳到digin-audio-production會導致目前的轉檔lambda被觸發，所以開新的bucket
    },
    "albumPhoto" : {
      "bucket" : `digins3-${bucketSuffix}`,
      "path" : "album_photo/",
      "source" : assetUrl
    },
    "creatorPhoto" : {
      "bucket" : `digins3-${bucketSuffix}`,
      "path" : "creator_photo/",
      "source" : assetUrl
    },
    "recommend" : {
      "bucket" : `digins3-${bucketSuffix}`,
      "path" : "recommend_ablum/",
      "source" : assetUrl
    },
    "emailAttachment" : {
      "bucket" : `digins3-${bucketSuffix}`,
      "path" : "email_attachment"
    },
    "inquiry" : {
      "bucket" : `digin-inquiry-${bucketSuffix}`,
      "path" : "file/",
      "source": inquiryUrl
    }
  }
};

const betaSetting = {
  "apiBaseUrl": process.env.MIX_ADMIN_API_BASE_URL || 'https://dev-digin.digin-music.net/api/v1/',
};

if (isBeta) {
  setting = {
    ...setting,
    ...betaSetting
  };
}

const prodSetting = {
  "apiBaseUrl": 'https://digin.digin-music.net/api/v1/',
  "S3": {
    region: 'ap-northeast-1',
    "audio": {
      "bucket" : "digin-audio-production",
      "path" : "audio/",
      "source" : "https://digin-audio-production.s3-ap-northeast-1.amazonaws.com/"
    },
    "mp3": {
      "bucket" : "digin-mp3-production",
      "path" : "audio/",
      "source" : "https://digin-mp3-production.s3.ap-northeast-1.amazonaws.com/" // or use cloudfront?
    },
    "wav": {
      "bucket" : "digin-wav-production",
      "path" : "audio/",
      "source" : "https://digin-wav-production.s3-ap-northeast-1.amazonaws.com/"
      // 因為上傳到digin-audio-production會導致目前的轉檔lambda被觸發，所以開新的bucket
    },
    "albumPhoto" : {
      "bucket" : "digins3-production",
      "path" : "album_photo/",
      "source" : "https://digins3-production.s3.ap-northeast-1.amazonaws.com/"
    },
    "creatorPhoto" : {
      "bucket" : "digins3-production",
      "path" : "creator_photo/",
      "source" : "https://digins3-production.s3.ap-northeast-1.amazonaws.com/"
    },
    "recommend" : {
      "bucket" : "digins3-production",
      "path" : "recommend_ablum/",
      "source" : "https://digins3-production.s3.ap-northeast-1.amazonaws.com/"
    },
    "emailAttachment" : {
      "bucket" : "digins3-production",
      "path" : "email_attachment"
    },
    "inquiry": {
      "bucket": "digin-inquiry-production",
        "path": "file/",
        "source": "https://digin-inquiry-production.s3.ap-northeast-1.amazonaws.com/"
      }
  }
};

if (isProd) {
  setting = {
    ...setting,
    ...prodSetting
  };
}

export default setting;
